export function Spinner({ lg }: { lg?: boolean }) {
  return <span className={`wb-spinner ${lg ? 'wb-spinner--lg' : ''}`} aria-hidden="true" />;
}
